import React from 'react';

import useOrganization from '~/components/OrganizationContext';
import useDataFetcher from '~/components/useDataFetcher';

import type { OrganizationUnit } from './types';

interface FetchOrgUnitsResult {
  isLoading: boolean;
  isError: boolean;
  units: OrganizationUnit[];
  isUnitLeader: (userId: string) => boolean;
}

export default function useFetchOrgUnits(config: { disabled?: boolean }): FetchOrgUnitsResult {
  config = { disabled: false, ...config };
  // @ts-expect-error useOrganization() not properly typed yet
  const { organizationId } = useOrganization();
  const url = `/api/v1/org_units/organizations/${organizationId}`;
  const { isLoading, isError, data } = useDataFetcher<OrganizationUnit[]>(url, undefined, !config.disabled);
  const units = data as OrganizationUnit[];

  const isUnitLeader = React.useCallback(
    (userId: string) => {
      if (isLoading || isError || !units) {
        return false;
      }
      return units.some((unit) => unit.leader_user_id === userId);
    },
    [isLoading, isError, units]
  );

  return { isLoading, isError, units, isUnitLeader };
}
